import { Component, ViewChild, OnInit,OnChanges,Output,EventEmitter } from '@angular/core';
import { RouterModule,Router,ActivatedRoute } from '@angular/router';
import { MatTable } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import { MatIconModule } from '@angular/material/icon';
import { TokenStorageService } from 'app/main/auth/token-storage.service';
import {FormBuilder, FormGroup,FormControl, Validators} from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { MatDrawer } from '@angular/material/sidenav';
import * as d3 from 'd3-selection';
import { SujetoObligadoService } from 'app/main/services/sujeto-obligado.service';
import { SujetoObligado } from 'app/main/models/sujeto-obligado.model';
import { ClientesService } from 'app/main/services/clientes.service';
import { Cliente } from 'app/main/models/cliente.model';
import { Location } from '@angular/common';
import { DebidaDiligenciaService } from 'app/main/services/debida-diligencia.service';

import { DialogBoxDebidaDiligenciaComponent } from '../../dialog/dialog-box-debida-diligencia.component';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { DebidaDiligencia } from 'app/main/models/debida-diligencia.model';
import { Contacto } from 'app/main/models/contacto.model';
import { TipoSujetoObligadoService } from 'app/main/services/tipo-sujeto-obligado.service';
import { TipoDocumentoService } from 'app/main/services/tipo-documento.service';
import { PaisService } from 'app/main/services/pais.service';
import { SectorActividadService } from 'app/main/services/sector-actividad.service';
import { ProfesionService } from 'app/main/services/profesion.service';
import { Direccion } from 'app/main/models/direccion.model';

const Parser = require('expr-eval').Parser;


@Component({
    selector   : 'cliente-sujeto-obligado-external-view',
    templateUrl: './cliente-sujeto-obligado-external-view.component.html',
    styleUrls  : ['./cliente-sujeto-obligado-external-view.component.scss']
})
export class ClienteSujetoObligadoExternalViewComponent implements OnInit,OnChanges
{
    //Cart Date
    multi: any[];
    view: any[] = [700, 350];

    viewSectorActividad = false;
    viewSProfesion = false;
    viewPEP = false;
    viewNombre = false;
    viewSegundoNombre = false;
    viewApellido = false;
    viewSegundoApellido = false;
    viewRazonSocial = false;
    viewDocumento = false;
    viewDocumentoFechaExpedicion = false;
    viewDocumentoFechaVencimiento = false;
    viewCorreoElectronico = false;
    viewTelefono = false;
    viewDireccion = false;
    viewDireccionFiscal = false;
    viewPais = false;
    viewFechaDeNacimiento = false;    


    dataSource = [];
    dataSourceI = [];
    dataSourceR = [];
    resultsList = [];

    pieDataExposiciones = [];

    legend: boolean = true;
    showLabels: boolean = true;
    animations: boolean = true;
    xAxis: boolean = true;
    yAxis: boolean = true;
    showYAxisLabel: boolean = true;
    showXAxisLabel: boolean = true;
    xAxisLabel: string = 'Probabilidad';
    yAxisLabel: string = 'Impacto';
    gradient: boolean = false;

    colorScheme = {
      domain: ['#34C229', '#F1F80C','#E44D25']
    };

    customColors = [];
    customColorsPie = [];

    displayedColumnsClientes: string[] = ['vencimiento','tipo','estado','beneficiario', 'razonSocial', 'sectorIndustrial', 'action'];
    displayedColumnsAccionistas: string[] = ['nombre', 'correoElectronico', 'action'];
    
    isEditable = false;
    isReseted = false;

    nombre:string = "";
    uuid :string = null;
    idSujetoObligado :number = null;
    is_eval_creador: boolean = false;
    editar_nombre: boolean = false;
    editar_tipo:boolean = false;
    editar_razon_social:boolean = false;
    
    debidasDiligencias:any = [];
    accionistas = [];

    cliente : any = null;
    clientsCount = 0;
    basicSlice = 10;

    tiposDocumentos = [];
    tiposSujetos = [];
    tiposSectorIndustrial = [];
    tiposProfesiones = [];
    paises = [];

    GENERAL_DATA: SujetoObligado = new SujetoObligado({});
  
    @ViewChild(MatTable, {static: true}) table: MatTable<any>;
    @ViewChild('tableAInherente', {static: true}) tableAInherente: MatTable<any>;
    @ViewChild('stepper') private stepper: MatStepper;
    @Output() selectedTabChange: EventEmitter<MatTabChangeEvent>
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

    //@ViewChild("stepper") stepper: MatStepper;


    constructor(public dialog: MatDialog,
                private storage: TokenStorageService,
                private service: ClientesService,
                private serviceDD: DebidaDiligenciaService,
                private _snackBar: MatSnackBar,
                public translate: TranslateService,
                private _formBuilder: FormBuilder,
                public router: Router,
                private location: Location,
                private serviceTipoSujetoObligado: TipoSujetoObligadoService,
                private serviceTipoDocumento: TipoDocumentoService,
                private servicePais: PaisService,
                private serviceSectorIndustrial: SectorActividadService,
                private serviceProfesion: ProfesionService,
                private route: ActivatedRoute) {}


    ngOnInit() {
      this.route.paramMap.subscribe(params => {
          this.uuid = params.get('uuid');

          this.serviceTipoSujetoObligado.getList().pipe().subscribe(req => {
            this.tiposSujetos = req.body.map( tipo => {
              console.log(tipo);
              return {
                id: tipo.id,
                nombre: tipo.nombre
              };
            });
      
          });
      
          this.serviceTipoDocumento.getList().pipe().subscribe(req => {
            this.tiposDocumentos = req.body.map( tipo => {
              console.log(tipo);
              return {
                id: tipo.id,
                nombre: tipo.nombre,
                tipo: tipo.tipo
              };
            });
          });
      
            this.servicePais.getList().pipe().subscribe(req => {
              this.paises = req.body.map( tipo => {
                console.log(tipo);
                return {
                  id: tipo.id,
                  nombre: tipo.nombre
                };
              });
          });
      
          
          this.serviceSectorIndustrial.getList().pipe().subscribe(req => {
            this.tiposSectorIndustrial = req.body.map( tipo => {
              console.log(tipo);
              return {
                id: tipo.id,
                nombre: tipo.nombre
              };
            });
          });
            
            this.serviceProfesion.getList().pipe().subscribe(req => {
              this.tiposProfesiones = req.body.map( tipo => {
                console.log(tipo);
                return {
                  id: tipo.id,
                  nombre: tipo.nombre
                };
              });
            });

          this.service.getByUTAccess(this.uuid).pipe().subscribe(req => {
            this.cliente = new Cliente(req);
            
            var user = this.storage.getUser();

            this.GENERAL_DATA = this.cliente.personaFisica || this.cliente.personaJuridica;

            if(this.GENERAL_DATA["contacto"]["telefonos"].length> 0){
              this.GENERAL_DATA.telefono = this.GENERAL_DATA["contacto"]["telefonos"][0];
              console.log(this.GENERAL_DATA.telefono);
            }

            if(this.GENERAL_DATA["contacto"]["correoElectronico"] != null){
              this.GENERAL_DATA.correoElectronico = this.GENERAL_DATA["contacto"]["correoElectronico"];
            }

            
            this.GENERAL_DATA.razonSocial = this.cliente.personaFisica ? this.cliente.personaFisica.documentoIdentidad : this.cliente.personaJuridica.razonSocial;
            if(this.GENERAL_DATA.razonSocial != null){
              this.viewDocumento = true;
              this.viewDocumentoFechaExpedicion = this.GENERAL_DATA["razonSocial"]["fechaExpedicion"] != null;
              this.viewDocumentoFechaVencimiento = this.GENERAL_DATA["razonSocial"]["fechaVencimiento"] != null;
            }

           //this.viewSectorActividad = this.GENERAL_DATA.sectorIndustrial != null;
            this.viewNombre = this.GENERAL_DATA.nombre != null;

            if(this.cliente.personaFisica){
              this.viewSProfesion = this.GENERAL_DATA["profesion"] != null;
              this.viewPEP = this.GENERAL_DATA["pep"] != null;
              this.viewSegundoNombre = this.GENERAL_DATA["segundoNombre"] != null;
              this.viewApellido = this.GENERAL_DATA["apellido"] != null;
              this.viewSegundoApellido = this.GENERAL_DATA["segundoApellido"] != null;
              this.viewFechaDeNacimiento = this.GENERAL_DATA["fechaDeNacimiento"] != null;
              this.viewPais = this.GENERAL_DATA["lugarNacimiento"] != null;

              this.cliente.personaFisica.contacto.direcciones.forEach(direccion => {
                if(direccion.tipo == 'FISICA') {
                  this.GENERAL_DATA.direccionFisica = direccion;
                  this.viewDireccion = true;
                }
  
              });
  
              if(this.GENERAL_DATA.direccionFisica == null){
                this.GENERAL_DATA.direccionFisica = new Direccion({});
              }
            }
            
            this.viewRazonSocial = (this.GENERAL_DATA.razonSocial != null) || (this.GENERAL_DATA["documentoIdentidad"] != null);
            this.viewCorreoElectronico = this.GENERAL_DATA.correoElectronico != null;
            this.viewTelefono = this.GENERAL_DATA.telefono != null;
            
        
            if(this.cliente.tipo == 'PERSONA_JURIDICA'){

              this.cliente.personaJuridica.contacto.direcciones.forEach(direccion => {
                if(direccion.tipo == 'FISCAL'){ 
                  this.GENERAL_DATA.direccionFiscal = direccion;
                  this.viewDireccionFiscal = true;
                }
                if(direccion.tipo == 'FISICA') {
                  this.GENERAL_DATA.direccionFisica = direccion;
                  this.viewDireccion = true;
                }
  
              });
  
              if(this.GENERAL_DATA.direccionFisica == null){
                this.GENERAL_DATA.direccionFisica = new Direccion({});
              }

              if(this.GENERAL_DATA.direccionFiscal == null){
                this.GENERAL_DATA.direccionFiscal = new Direccion({});
              }

              this.service.getAccionistas(this.cliente.id).
              pipe().subscribe(req => {
                this.accionistas = req.body.map( so => {
                   return so;

                });
              });
            }

          });

          this.serviceDD.countByCliente(this.cliente.id).subscribe(req => {
            this.clientsCount = req.body;
          });
          this.getDDPaginator(0);

            

      });

    }
    
    getDDPaginator(page): void {

      this.serviceDD.getAllByCliente(this.cliente.id,page,this.basicSlice).
          pipe().subscribe(req => {
            this.debidasDiligencias = req.body.map( so => {

              return so;

            });
          });
    }

    ngAfterViewChecked(){
      //this.actualizarColores();
    }

    ngOnChanges() {
      //this.actualizarColores();
    }

    enviarComentario():void{

      /*
      const dialogRef = this.dialog.open(DialogBoxClienteAddCommentComponent, {
        width: '450px',
        data: this.cliente.id
      });
  
      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
        if(result.event == 'Add'){
          this.service.addComment(result.data).subscribe(req => {
            this.openSnackBar("Comentario enviado correctamente","Cerrar");
          });
        }
      });
      */

    }

    guardaeCambios():void{

      if(this.cliente.tipo=='PERSONA_FISICA'){
        //this.cliente.personaFisica.sectorIndustrial = this.GENERAL_DATA.sectorIndustrial;
        this.cliente.personaFisica.contacto = new Contacto({});
        
        this.cliente.personaFisica.contacto.addCorreo(this.GENERAL_DATA.correoElectronico);
        this.cliente.personaFisica.contacto.addTelefono(this.GENERAL_DATA.telefono);
        this.GENERAL_DATA.direccionFisica.tipo = 'FISICA';
        this.cliente.personaFisica.contacto.addDireccion(this.GENERAL_DATA.direccionFisica);
        this.cliente.personaFisica.documentoIdentidad = this.GENERAL_DATA.razonSocial;
        
      }

      if(this.cliente.tipo=='PERSONA_JURIDICA'){
        //this.cliente.personaJuridica.sectorIndustrial = this.GENERAL_DATA.sectorIndustrial;
        this.cliente.personaJuridica.contacto = new Contacto({});
        
        this.cliente.personaJuridica.contacto.addCorreo(this.GENERAL_DATA.correoElectronico);
        this.cliente.personaJuridica.contacto.addTelefono(this.GENERAL_DATA.telefono);
        this.GENERAL_DATA.direccionFisica.tipo = 'FISICA';
        this.cliente.personaJuridica.contacto.addDireccion(this.GENERAL_DATA.direccionFisica);
        this.GENERAL_DATA.direccionFisica.tipo = 'FISCAL';
        this.cliente.personaJuridica.contacto.addDireccion(this.GENERAL_DATA.direccionFiscal);
        this.cliente.personaJuridica.razonSocial = this.GENERAL_DATA.razonSocial;
        
      }

      this.service.editExternal(this.cliente.id,this.cliente).subscribe(req => {
        this.openSnackBar("Se guardaron los cambios correctamente","Cerrar");
        //Reload the page
        this.ngOnInit();
      });

    }


    navegateTo(url, uuid): void  {
      this.router.navigate([url,uuid]).then( (e) => {
        if (e) {
          console.log("Navigation is successful!");
        } else {
          console.log("Navigation has failed!");
        }
      });
  }

    back() {
      this.location.back();
    }

    print():void{

    }

    
    OnePageChange(event: PageEvent) {
      this.basicSlice = event.pageSize;
      this.getDDPaginator(event.pageIndex);
    }


    openSnackBar(message: string, action: string) {
      this._snackBar.open(message, action, {
        duration: 3000,
      });
    }

    delay(ms: number) {
      return new Promise( resolve => setTimeout(resolve, ms) );
    }

    compareObjects(o1: any, o2: any): boolean {
      return o1.nombre === o2.nombre && o1.id === o2.id;
    }

    esOwnersGroup(usuario):boolean{

      var esOwner:boolean = false;

      usuario.tipos.forEach(element => {
        if(element.id == 4)
          esOwner = true;
      });

      return esOwner;
    }

    public tabChanged(tabChangeEvent: MatTabChangeEvent): void {
      console.log(tabChangeEvent);
      console.log("Entro a tabChanged para actualizar los resultados");
      if(tabChangeEvent.tab.textLabel=="Análisis Residual"){
        
      }
      //this.calcularResultadosOriginal();
    }


 
    

}
